import { sendGet } from "../networking";

export function isLoggedIn() {
    return sendGet<{loggedIn: boolean}>('/internal/auth/api/authenticated');
}

